import * as React from "react";
import {observer} from "mobx-react";

import "./station-document.scss";

interface StationDocumentProps {
    url: string;
    title?: string;
}

@observer
export class StationDocument extends React.Component<StationDocumentProps, any> {
    constructor(props: StationDocumentProps) {
        super(props);
        this.state = {};
    }

    render() {
        const url = this.props.url || "";
        const title = this.props.title || url.split("/").pop();

        if (!url.length) {
            return null;
        }

        return (
            <div className="geo-station-document">
                <a href={url}
                   title={title}
                   target="_blank"
                >
                    {title}
                </a>
            </div>
        );
    }
}
